import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';

@Injectable()
export class PushNotificationsProvider {
  private readonly basePath = 'v3/adm/push-notifications';

  constructor(private api: ApiProvider) {}

  automations(appContext: string) {
    return this.api.get(`${this.basePath}/automations`, { params: { app_context: appContext } });
  }

  updateAutomation(key: string, enabled: boolean) {
    return this.api.patch(`${this.basePath}/automations/${key}`, { enabled });
  }

  campaigns(params: any = {}) { return this.api.get(`${this.basePath}/campaigns`, { params }); }
  createCampaign(data: any) { return this.api.post(`${this.basePath}/campaigns`, data); }
  sendCampaign(id: number) { return this.api.post(`${this.basePath}/campaigns/${id}/send`); }

  subscriber(externalId: string, appContext: string) {
    return this.api.get(`${this.basePath}/subscribers/${encodeURIComponent(externalId)}`, {
      params: { app_context: appContext },
    });
  }

  sendTest(data: any) { return this.api.post(`${this.basePath}/test`, data); }
  history(params: any = {}) { return this.api.get(`${this.basePath}/history`, { params }); }

  syncDelivery(id: number, appContext: string) {
    return this.api.post(`${this.basePath}/deliveries/${id}/sync`, { app_context: appContext });
  }
}
